import { SpreadsheetAppearance, SpreadsheetData } from "./types";

interface SpreadsheetRowLookAttributes {
    "data-total"?: "";
    "data-group-end"?: "";
}

/**
 * Row attributes the report and list looks style: `data-total` on total rows
 * (`_isTotal`), and `data-group-end` when the next rendered row is top-level,
 * which is where the report look draws its row lines. The default look gets
 * none.
 */
export function getSpreadsheetRowLookAttributes({
    appearance,
    data,
    rowIdx,
}: {
    appearance: SpreadsheetAppearance;
    data: SpreadsheetData;
    rowIdx: number;
}): SpreadsheetRowLookAttributes {
    if (appearance === "spreadsheet") {
        return {};
    }
    const nextDepth = data[rowIdx + 1]?._depth;
    const isGroupEnd = typeof nextDepth !== "number" || nextDepth === 0;
    return {
        "data-total": data[rowIdx]?._isTotal === true ? "" : undefined,
        "data-group-end": isGroupEnd ? "" : undefined,
    };
}
